import { logEvent as firebaseLogEvent } from 'firebase/analytics';

import { analytics } from 'app/utils';

export const logEvent = (event) => {
  firebaseLogEvent(analytics, event);
}


